import { FaMap } from "react-icons/fa";

export default FaMap;